// extracted by mini-css-extract-plugin
module.exports = {"infoBody":"filtersInfo-module_infoBody_ed2ac","textBlock":"filtersInfo-module_textBlock_b56a1"};